


import { useState } from "react";

export default function Section9() {
  const [isOpen, setIsOpen] = useState(new Array(5).fill(false));
  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full Section8 mt-[8%] md:mt-[4%]">
      <div className="w-full section8-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">

          {/* FAQ 1 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(0)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              How long does it take to build a WordPress website?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[0] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[0] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                The typical timeline for a WordPress project is 6–8 weeks, depending on the size and complexity of the website. We will work closely with you to set clear milestones and timelines so you know exactly what to expect.
              </p>
            </div>
          </div>

          {/* FAQ 2 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(1)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              How much does a WordPress website cost?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[1] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[1] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                The cost of a WordPress website can vary based on your specific requirements. For a custom quote, please contact us to discuss your project in detail, and we’ll provide a tailored estimate based on your needs.
              </p>
            </div>
          </div>

          {/* FAQ 3 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(2)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Do I need to update my WordPress website regularly?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[2] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[2] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                Yes, regular updates are essential to keep your site secure and running smoothly. We offer maintenance services to handle these updates, ensuring your site stays current and protected from any vulnerabilities.
              </p>
            </div>
          </div>

          {/* FAQ 4 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(3)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Will my WordPress website be SEO optimized?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[3] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[3] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                Absolutely! We ensure all of our WordPress websites are built with SEO best practices in mind. From site structure to content optimization, we work to improve your site's visibility and help it rank higher in search engine results.
              </p>
            </div>
          </div>

          {/* FAQ 5 */}
          <div
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
            style={{
              background:
                "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
            }}
          >
            <div
              onClick={() => handleFaq(4)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Can you provide ongoing support for my WordPress site?
              <b className="text-[40px] text-[#DA2128] font-[300]">{isOpen[4] ? "-" : "+"}</b>
            </div>
            <div className={`${isOpen[4] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p className="mb-5">
                Yes, we offer ongoing support and are always available to assist with any issues, updates, or improvements. We’ll make sure your website stays functional, secure, and optimized for the long run.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}